export enum InvitationRoleTypeEnum {
    TEAM_MEMBER = "TEAM_MEMBER",
    PARTNER = "PARTNER",
    EXPERT = "EXPERT",
    LEADER = "LEADER",
    TRACKER = "TRACKER",
    OTHER = "OTHER",
}
